module.exports = __webpack_public_path__ + "img/processing_light.8b2dead5.svg";